import { gql } from '@apollo/client';

export const fetchInternalLicensesForTransactionAccountPPC = gql`
  query fetchInternalLicensesForTransactionAccountPPC(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
    $isRestricted: Boolean
    $fetchIsExternallyEnabled: Boolean = false
    $relatedDomains: [String]!
  ) {
    transactionAccount(id: $id) {
      id
      internalUseSubscriptions(
        searchOptions: $searchOptions
        filterOptions: $filterOptions
        relatedDomains: $relatedDomains
      ) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          id
          logoId
          activeSubscriptionBillingGroupId
          activeUsers
          baseProduct
          createdDate
          billingStatus
          entitlementNumber
          transactionAccountNumber
          latestPeriodEndDate
          latestPeriodStartDate
          productName
          productId
          cloudSiteId
          cloudSiteHostname
          billingFrequency
          edition
          provisioningStatus
          billingGroupId
          billedUsers
          isFutureDatedSubscription
          trial
          isSandbox
          pricingPlan {
            id
            type
          }
          relatesFromEntitlements {
            relationshipType
            entitlementId
          }
          relatesToEntitlements {
            relationshipType
            entitlementId
          }
          linkedAppsId
          linkedAddOnsId
          endCustomerContacts(isRestricted: $isRestricted) {
            accountId
            name
            picture
            email
          }
          isAddOn
          chargeQuantities {
            chargeElement
            quantity
          }
          subscriptionTimestamps {
            firstStartTimestamp
            lastEndTimestamp
            firstTrialStartTimestamp
            lastTrialEndTimestamp
          }
          upgradeTrial {
            startTimestamp
            endTimestamp
          }
          orgId
          orgName
          scheduledChanges {
            subscriptionScheduleAction
            offering {
              id
            }
            pauseBilling {
              startTimestamp
              endTimestamp
            }
          }
          endTimestamp
          endBehaviour
          trialStartDate
          trialEndDate
          offering {
            id
            pricingType
            name
          }
          pauseBilling {
            startTimestamp
            endTimestamp
          }
          isExternallyBilled @include(if: $fetchIsExternallyEnabled)
          userTier
        }
      }
    }
  }
`;
